import updateDataView from '@/store/data-view/actions/updateDataView';
import createDataView from '@/store/data-view/actions/createDataView';
import getDataView from '@/store/data-view/actions/getDataView';
import getDataViewItems from '@/store/data-view/actions/getDataViewItems';
import getDataViews from '@/store/data-view/actions/getDataViews';

export default {
  updateDataView,
  createDataView,
  getDataView,
  getDataViewItems,
  getDataViews,
}